module.exports = __webpack_public_path__ + "static/media/oil-truck.e82bc9e0.png";